import { render, staticRenderFns } from "./WebsiteManageProducts.vue?vue&type=template&id=b3e713e0&"
import script from "./WebsiteManageProducts.vue?vue&type=script&lang=js&"
export * from "./WebsiteManageProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports